import { media } from '@sail/engine';
import { tokens, css } from '@sail/ui';
import { ROW_GAP_SIZES, helmTokens } from '../../theme';
export const styles = {
    columnLayout: css({
        display: 'grid',
        grid: 'auto / minmax(0, 1fr)'
    }),
    globalColumnLayout: css.global({
        [media.down(tokens.viewport.medium)]: {
            '[data-state-column-count="2,2"][data-state-reflow-direction="rightToLeft"] > *:first-child': {
                order: 1
            }
        },
        [media.down(tokens.viewport.large)]: {
            '[data-state-column-count="1,3"]:not([data-state-reflow-direction="leftToRight"]) > *:first-child': {
                order: 1
            },
            '[data-state-column-count="3,1"][data-state-reflow-direction="rightToLeft"] > *:first-child': {
                order: 1
            },
            '[data-state-column-count="3,2"][data-state-reflow-direction="rightToLeft"] > *:first-child': {
                order: 1
            }
        },
        [media.between(tokens.viewport.small, tokens.viewport.large)]: {
            '[data-state-column-count="2,1,1"] > *:first-child': {
                gridArea: '1 / span 2'
            }
        }
    })
};
export const variants = {
    rowGap: ROW_GAP_SIZES.reduce((acc, size)=>{
        acc[size] = css({
            rowGap: `${helmTokens.layout.rowGap[size]}`
        });
        return acc;
    }, {}),
    align: {
        start: css({
            alignItems: 'start'
        }),
        center: css({
            alignItems: 'center'
        }),
        end: css({
            alignItems: 'end'
        }),
        stretch: css({
            alignItems: 'stretch'
        })
    }
};

//# sourceMappingURL=ColumnLayoutStyles.js.map